import axios from 'axios';

export default class Request {
  static getAsync(url, options = {}) {
    return axios(url, options);
  }
}
